/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';

import { SortableList } from '@molecules';
import { Block, Button } from '@atoms';

import { FORM_FIELD } from './constants';
import AddChannelForm from './AddChannelForm';
import SlideItem from './SlideItem';
import s from './styles.module.less';

const EventChannels = ({ countries: countriesList, initialValues: initData, whereToWatchDays, form: _form }) => {
  const [open, setOpen] = React.useState(false);
  const [channels, setChannels] = React.useState(initData[FORM_FIELD.GENERAL_CHANNELS.name]);

  const syncChannels = React.useCallback(
    (_channels) => {
      _form.setFields([{ name: FORM_FIELD.GENERAL_CHANNELS.name, value: _channels }]);
      setChannels(_channels);
    },
    [_form],
  );

  const handleAdd = React.useCallback(
    (channel) => syncChannels([channel, ...(_form.getFieldValue(FORM_FIELD.GENERAL_CHANNELS.name) || [])]),
    [_form, syncChannels],
  );

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  const toggleFormVisibility = () => {
    setOpen(true);
  };

  return (
    <>
      <Button type="customBlue" onClick={toggleFormVisibility} style={{ marginBottom: 20 }}>
        ADD CHANNEL
      </Button>
      {open && (
        <Block>
          <AddChannelForm
            whereToWatchDays={whereToWatchDays}
            countriesList={countriesList}
            handleClose={handleClose}
            className={s.addForm}
            onSubmit={handleAdd}
          />
        </Block>
      )}
      {/* <ChannelsList
        channels={channels}
        countriesList={countriesList}
        syncChannels={syncChannels}
        handleClose={handleClose}
        whereToWatchDays={whereToWatchDays}
      /> */}
      {!!channels?.length && (
        <div style={{ marginTop: 20 }}>
          <SortableList onChange={syncChannels} label="Channels" value={channels}>
            {(value, { edit, isEdit, save, buttons }) =>
              isEdit ? (
                <AddChannelForm
                  countriesList={countriesList}
                  handleClose={handleClose}
                  initialValues={value}
                  buttons={buttons}
                  onSubmit={save}
                />
              ) : (
                <SlideItem handleEdit={edit}>{`${value?.title} - ${value?.category}`}</SlideItem>
              )
            }
          </SortableList>
        </div>
      )}
    </>
  );
};

export default EventChannels;
